/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var moment = require('moment');
var _get = require('lodash.get');

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(formData) {
  var deferred = $.Deferred();

  formData.openedDate = formData.openedDate ? moment(formData.openedDate, 'MM/DD/YYYY').format('YYYY-MM-DD') : '';
  var examStaffs = formData.examStaffs || [];

  $.soap({
    body: {
      SubmitNewExam: {
        $xmlns: 'http://dobs.pa.gov/sc/exam/bpm/1.0',
        OrganizationID: formData.organizationId,
        OrganizationLicenseID: formData.organizationLicenseId,
        StatusID: formData.statusId,
        Description: formData.description,
        TypeID: formData.typeId,
        SubtypeID: formData.subtypeId,
        BranchCRDNumber: formData.branchCRDNumber,
        CategoryID: formData.categoryId,
        ConductedLocationID: formData.conductedLocationId,
        LocationForExam: formData.locationForExam,
        OfficeAssignedID: formData.officeAssignedId,
        SourceID: formData.sourceId,
        PrimaryExaminer: formData.primaryExaminer,
        IsDeficienciesFound: formData.isDeficienciesFound,
        DeficienciesLetterSent: formData.deficienciesLetterSent,
        OpenedDate: formData.openedDate,
        ExamStaffs: (function() {
          if (!examStaffs.length) {
            return {};
          }
          return _.map(examStaffs, function(examStaff) {
            return {
              ExamStaff: {
                FunctionID: examStaff.functionId,
                StaffMember: examStaff.staffMember,
                AssignedDate: examStaff.assignedDate,
                RemovedDate: examStaff.removedDate
              }
            };
          });
        })(),
        Documents: (function() {
          if (!_get(formData, 'documents.length')) {
            return {};
          }
          return _.map(formData.documents, function(document) {
            return { Document: { DocumentID: document.fileId, DocumentTypeID: document.documentTypeId } };
          });
        })()
      }
    },
    blueprint: {
      examId: '$..ExamID.__text'
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      deferred.resolve(response.examId);
    })
    .fail(function(err) {
      deferred.reject();
    });

  return deferred.promise();
};
